import { useState } from "react";
import { get_userLogin } from "../apis/services/csaApi";

export default function SignIn({ onSignIn }) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    language: "en-US", // default
    remember: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSignIn = () => {
    const { username, password, remember } = formData;
    if (username && password) {
      get_userLogin(username, password).then((response) => {
        console.log("response", response);
        if (response && response.length > 0) {
          const user = response[0];

          const userInitial = user.userName?.charAt(0).toUpperCase() || "";

          // Save to both localStorage and sessionStorage
          const saveToBothStorages = (key, value) => {
            localStorage.setItem(key, value ?? "");
            // sessionStorage.setItem(key, value ?? "");
          };

          saveToBothStorages("bottlerGroup", user.bottlerGroup);
          saveToBothStorages("bottlerName", user.bottlerName);
          saveToBothStorages("bottlerUnit", user.bottlerUnit);
          saveToBothStorages("doe", user.doe);
          saveToBothStorages("name", user.name);
          saveToBothStorages("password", user.password); // ❗ optional, for security you can skip
          saveToBothStorages("language", formData.language);
          saveToBothStorages(
            "languageId",
            formData.language === "en-US" ? 1 : 2
          );
          saveToBothStorages("uId", user.uId?.toString());
          saveToBothStorages("userName", user.userName);
          saveToBothStorages("userType", user.userType);
          saveToBothStorages("initial", userInitial);

          onSignIn(remember, userInitial);
        }
      });
    } else {
      alert("Invalid username or password");
    }
  };

  return (
    <div className="signIn-wrapper">
      <div className="signIn-bg">
        <img src="/assets/signInPage/signInBG.webp" alt="" />
      </div>
      <div className="signIn-bg-overlay"></div>
      <div className="signIn-content">
        <form
          className="login-form"
          onSubmit={(e) => e.preventDefault()}
          // onKeyDown={handleKeyDown}
        >
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              name="username"
              placeholder="Enter your username"
              value={formData.username}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              placeholder="Enter your password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="language">Default Language</label>
            <div className="custom-select">
              <div
                className="select-header"
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              >
                {formData.language === "en-US" ? "English" : "中文 (Chinese)"}
                <span className={`arrow ${isDropdownOpen ? "open" : ""}`}>
                  ▼
                </span>
              </div>

              {isDropdownOpen && (
                <div className="select-options">
                  <div
                    className={`option ${
                      formData.language === "en-US" ? "selected" : ""
                    }`}
                    onClick={() => {
                      setFormData({ ...formData, language: "en-US" });
                      setIsDropdownOpen(false);
                    }}
                  >
                    English
                  </div>
                  <div
                    className={`option ${
                      formData.language === "zh-CN" ? "selected" : ""
                    }`}
                    onClick={() => {
                      setFormData({ ...formData, language: "zh-CN" });
                      setIsDropdownOpen(false);
                    }}
                  >
                    中文 (Chinese)
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="form-group remember-me">
            <input
              type="checkbox"
              id="remember"
              name="remember"
              checked={formData.remember}
              onChange={handleChange}
            />
            <label htmlFor="remember">Remember Me</label>
          </div>

          <div className="form-group">
            <button type="button" onClick={handleSignIn} className="login-btn">
              Log In
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
